// Reads the non-HttpOnly double-submit cookie issued by /auth/callback so
// state-changing requests can echo it as X-CSRF-Token.
let recovery: Promise<string> | undefined

export function readCsrfCookie(): string {
  if (typeof document === 'undefined') return ''
  const prefix = 'wippy_csrf='
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim()
    if (trimmed.startsWith(prefix)) return trimmed.slice(prefix.length)
  }
  return ''
}

// Ensures the readable double-submit cookie exists. Concurrent callers share
// one bounded GET; ordinary mutations are never retried generically.
export async function ensureCsrfCookie(): Promise<string> {
  const existing = readCsrfCookie()
  if (existing) return existing
  if (!recovery) {
    recovery = (async () => {
      const response = await fetch('/auth/csrf', {
        method: 'GET',
        credentials: 'include',
        headers: { Accept: 'application/json' },
      })
      if (!response.ok) throw new Error(`GET /auth/csrf: ${response.status}`)
      const token = readCsrfCookie()
      if (!token) throw new Error('GET /auth/csrf did not issue a CSRF cookie')
      return token
    })().finally(() => {
      recovery = undefined
    })
  }
  return recovery
}
